<template>
  <person-detail :view-mode="'create'" />
</template>

<script>
import PersonDetail from "./components/detail";

export default {
  name: "StaffingCreate",
  components: { PersonDetail }
};
</script>

